import * as Yup from 'yup'
import { Currency } from '../asset-holders/Currency'

export interface CreateDisbursementInstructionPayload {
  currencyCode: string
  assetHolderId: number
  disbursementAccountId: number
  requestedPayoutAmount: number
  payoutSchedule: string
  otp: string
}

export const validateCreateDisbursementInstructionPayload = (): any => {
  return Yup.object().shape({
    currencyCode: Yup.string()
      .required('currency required'),
    disbursementAccountId: Yup.number().required('account required'),
    requestedPayoutAmount: Yup.number().required('amount required'),
    payoutSchedule: Yup.string().required('schedule required')
  })
}

export interface CreateDisbursementInstructionForm {
  currencyCode: string
  disbursementAccountId: number | null
  requestedPayoutAmount: number
  payoutSchedule: string
}

export interface DisbursementBitcoinAddress {
  accountType: 'BitcoinAddress'
  bitcoinAddress: string
}

export interface DisbursementBankAccount {
  accountType: 'BankAccount'
  accountHolderName: string
  bankName: string
  bankAccountNumber: string
  branchCode: string
}

export interface CreateDisbursementAccountPayload {
  currencyCode: string
  assetHolderId: number
  accountDetails: DisbursementBitcoinAddress | DisbursementBankAccount
  otp: string
}

export interface VerifyDisbursementAccountPayload {
  assetHolderId: number
  token: string
}

export const validateCreateDisbursementAccountPayload = (): any => {
  return Yup.object().shape({
    currencyCode: Yup.string().required('currency required'),
    assetHolderId: Yup.number().required('asset holder ID required'),
    accountDetails: Yup.object().required().when('currencyCode', {
      is: Currency.XBT,
      then: (schema) => schema.shape({
        accountType: Yup.string().matches(/BitcoinAddress/).required('Missing BitcoinAddress account type'),
        bitcoinAddress: Yup.string().required('bitcoin address required')
      }),
      otherwise: (schema) => schema.shape({
        accountType: Yup.string().matches(/BankAccount/).required('Missing BankAccount account type'),
        accountHolderName: Yup.string().required('account holder name required'),
        bankName: Yup.string().required('bank name required'),
        bankAccountNumber: Yup.string().required('bank account number required'),
        branchCode: Yup.string().required('branch code required')
      })
    })
  })
}

// const validateDisbursementBankAccount = (): any => {
//   return Yup.object().shape({
//     accountType: Yup.string().matches(/BankAccount/).required('Missing BankAccount account type'),
//     accountHolderName: Yup.string().required('Please enter an account holder name.'),
//     bankName: Yup.string().required('Please enter a bank name.'),
//     bankAccountNumber: Yup.string().required('Please enter a bank account number.'),
//     branchCode: Yup.string().required('Please enter a branch code.')
//   })
// }

// const validateDisbursementBitcoinAddress = (): any => {
//   return Yup.object().shape({
//     accountType: Yup.string().matches(/BitcoinAddress/).required('Missing BitcoinAddress account type'),
//     bitcoinAddress: Yup.string().required('Please enter a bitcoin address.')
//   })
// }
//

// ==============================================================================================================
//  Charity options
// ==============================================================================================================

export interface CharityOrganisationDetails {
  organisationName: string
  organisationId: number
  assetHolderId: number
  websiteUrl: string
}

export interface CreateCharityDisbursementPayload {
  assetHolderId: number
  selectedCharityOrganisationId: number | null
  otp: string
}

// export const validateCashOutOptionPayload = (): any => {
//   return Yup.object().shape({
//     assetHolderId: Yup.number().required('Asset holder ID not set.'),
//     selectedCharityOrganisationId: Yup.number().required('Please select one of the charities to donate to.'),
//     otp: Yup.string().required('otp address required')
//   })
// }

export interface CharityDisbursementDetails {
  assetHolderId: number
  charityDisbursementId: number
  selectedCharityAssetHolderId: number
  selectedCharityName: string
  currencyCode: string
  amount: number
  amountFormatted: string
  processedAtFormatted: string
}
